"use client";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  console.error(error);
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-text-primary mb-4">Something went wrong</h1>
        <p className="text-lg text-gray-600">Please try again.</p>
      </div>
    </div>
  );
}
